import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import './contactus.css';
import CustomMap from './CustomMap';

const ContactUs = () => {
  return (
    <div>
      <div className="contact-page-intro">
        <div className="container">
          <h2>Contattaci</h2>
          <p className="align-left">
            Siamo qui per aiutarti! Se hai bisogno di informazioni, supporto o vuoi semplicemente metterti in contatto con noi, utilizza i dettagli qui sotto oppure compila il modulo.
          </p>
        </div>
      </div>

      {/* Google Map */}
<section className="google-map">
<CustomMap />

</section>


      {/* Contact Info Section */}
      <section className="contact-section">
        <div className="container">
          <div className="row row-30 justify-content-center">

            {/* Phone */}
            <div className="col-sm-8 col-md-6 col-lg-4">
            <article className="box-contacts">
              <div className="phone-row">
                <FontAwesomeIcon icon={faMobileAlt} style={{ color: '#673ab7', fontSize: '20px', marginRight: '10px' }} />
                <a href="tel:+393338065959">+39 333 806 5959</a>
              </div>
              <div className="phone-row">
                <FontAwesomeIcon icon={faPhone} style={{ color: '#e91e63', fontSize: '20px', marginRight: '10px' }} />
                <a href="tel:+390814244274">+39 081 424 4274</a>
              </div>
            </article>
            </div>

            {/* Address */}
            <div className="col-sm-8 col-md-6 col-lg-4">
            <article className="box-contacts">
              <div className="box-contacts-icon">​📍</div>
              <p className="box-contacts-link address-text">
              Via Giuseppe Verdi, 46 - 80038 Pomigliano d'Arco (NA), Italia
              </p>
            </article>
            </div>

            <div className="col-sm-8 col-md-6 col-lg-4">
              <article className="box-contacts">
                <div className="box-contacts-icon">💬</div>
                <p className="box-contacts-link">
                  <a href="mailto:assistenza@techetour.it">assistenza@techetour.it</a>
                  <a href="mailto:info@techetour.it">info@techetour.it</a>
                </p>
              </article>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="section section-sm section-last bg-default text-left">
        <div className="container">
          <article className="title-classic">
            <div className="title-classic-title">
              <h3>Get in touch</h3>
            </div>
          </article>

          
          <form className="rd-form rd-form-variant-2" method="POST" action="https://formsubmit.co/emozionartisrl@gmail.com">
          
            <div className="row row-14 gutters-14">
              <div className="col-md-4">
                <div className="form-wrap">
                  <label htmlFor="name">
                    Nome
                    <input className="form-input" id="name" type="text" name="name" required />
                  </label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-wrap">
                  <label htmlFor="email">
                    E-mail
                    <input className="form-input" id="email" type="email" name="email" required />
                  </label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-wrap">
                  <label htmlFor="phone">
                    Tel
                    <input className="form-input" id="phone" type="text" name="phone" />
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-wrap">
                  <label htmlFor="message">Message</label>
                  <textarea className="form-input textarea-lg" id="message" name="message" required></textarea>
                </div>
              </div>
            </div>
            <button className="button button-primary" type="submit">Invia</button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
